import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    ojos: [],
  },

  getters: {
    getOjos: (state) => state.ojos,
  },

  mutations: {
    SET_OJOS(state, ojos) {
      state.ojos = ojos;
    },
  },

  actions: {
    async fetchOjos({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catOjos')
        .then((response) => {
          commit('SET_OJOS', response.data.data);
        });
    },
  },
};
